import { useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { ROUTES } from "../utils/Routes";
import { listen } from "../hooks/Listener";
import { createModal } from "../hooks/createModal";
import Menu from "../ui/Menu";
import Card from "../ui/Card";
import Label from "../ui/Label";
import ReportsCustomInventory from "../components/ReportsCustomInventory";
import Divider from "../ui/Divider";
import Cookies from "js-cookie";
import Space from "../ui/Space";
import Nav from "../ui/Nav";
import ProcessingList from "../components/ProcessingList";
import { pubCall, pubCallAsync } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import ProcessingDetails from "../components/ProcessingDetails";
import OrdersList from "../components/OrdersList";
import OrdersDetails from "../components/OrdersDetails";
import OrdersSearch from "./OrdersSearch";
import { drawPicker } from "../popovers/Picker";
import InventoryDetails from "../components/InventoryDetails";
import CustomersController from "./CustomersController";
import { createScreen } from "../hooks/createScreen";
import OrderFilter from "../popovers/OrderFilter";

export const get_initial = ({ sort = "", limit = 0, order_id = null }, callback = () => { }, async = false) => {
    let _obj = { sort: sort, limit: limit };
    if (order_id) {
        _obj.order_id = order_id;
    }
    const endpoint = "order.getInitial";
    if (async) {
        return pubCallAsync(endpoint, _obj);
    } else {
        pubCall(endpoint, _obj, (_s, _r) => { callback(_s, _r) })   
    }
}

export default function OrdersController(props) {

    const { controller = "", signal = {}, setController = () => { } } = props;

    const route = ROUTES.ORDERS.ORDERS;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState(null);
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [pagination, setPagination] = useState({
        limit: 40,
        offset: 0,
    });

    const [state, setState] = useState({
        edit: false,
        view: "orders",
    })


    useEffect(() => {

        if (state.view === "inventory") {
            return;
        }
        if (state?.edit) {
            window.bm_state.value = ROUTES.ORDERS.EDIT
        } else {
            window.bm_state.value = ROUTES.ORDERS.ORDERS;
        }

    }, [state])


    const toggleInventory = () => {
        if (state.view === "orders") {
            setState(prev => ({
                ...prev,
                view: "inventory",
            }));
        }

        if (state.view === "inventory") {
            setState(prev => ({
                ...prev,
                view: "orders",
            }));
        }
    }

    const [selected, setSelected] = useState({});
    const [selectedItem, setSelectedItem] = useState({});
    const [items, setItems] = useState([]);
    const [align, setAlign] = useState("auto");
    const [view, setView] = useState(true);
    const [edit, setEdit] = useState(false);
    const [filters, setFilters] = useState({ limit: 45, sort: "id" })
    const row_key = "order_id";

    const order_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { key: KBD.ENTER, action: () => { toggleInventory() } },
        { text: "Adj" },
        { text: "Cpy" },
        { text: "Del" },
        { key: KBD.E, text: "Edt", action: () => setState({ ...state, edit: true }) },
        { text: "@Edt" },
        { text: "Hst" },
        { key: KBD.I, text: "Indx", action: () => drawIndex() },
        { text: "Lbl" },
        { text: "Mass" },
        { text: "New" },
        { text: "Ord" },
        { text: "Prt" },
        { text: "Rsv" },
        { key: KBD.S, text: "Srch", action: () => { showSearch() } },
        { text: "Trf" },
        { key: KBD.V, text: "View", action: () => { viewCustomer() } },
        { text: "Wrev" },
        { text: "Zret" },
        { key: KBD.F, action: () => { openSpecial(); } }

    ]

    useEffect(() => {

        const cleanup = listen(controller, route, order_nav);
        return cleanup;
    }, [order_nav, selected, state])

    const openSpecial = () => {
        window.bm_state.value = ROUTES.ORDERS.FILTER;
        createModal({
            closable: true,
            title: "Active special orders filters",
            component: <OrderFilter
                controller={controller}
                setData={setData}
                setSelected={setSelected}
                route={ROUTES.ORDERS.FILTER}
            />,
            callback: () => {
                window.bm_state.value = ROUTES.ORDERS.ORDERS;
            }

        })
    }


    const viewCustomer = () => {

        if (!selected?.customer) {
            showError({ error: "View Customer card orly works if order linked to Customer" })
            return;
        }

        const _retroute = window.bm_state.value;
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        createScreen({
            signal: signal,
            component: <CustomersController controller={controller} is_modal initData={{ rows: [selected?.customer] }} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "View Customer",
            callback: (_obj) => {
                window.bm_state.value = _retroute;
            }
        });

    }


    const drawIndex = () => {

        const return_route = window.bm_state.value;
        const index_options = [
            { label: "Entry", value: "id" },
            { label: "Date (active only)", value: "date" },
            { label: "Review dates", value: "review_date" },
            { label: "Title", value: "title" },
            { label: "ISBN", value: "isbn" },
            { label: "Supplier", value: "supplier" },
            { label: "Order", value: "order" },
            { label: "CustAcct", value: "cust_acct" },
            { label: "Active Special orders", value: "active_special_orders" },
        ]

        drawPicker({
            controller: controller,
            value: filters?.sort, title: "Index", closeable: true, height: 300, route: route, close: () => { window.bm_state.route = return_route; }, callback: (e) => {
                setFilters({ ...filters, "sort": e })
                window.bm_state.route = return_route;
            }, offset: [0, 10],
            options: index_options
        })

    }


    const showSearch = () => {
        window.bm_state.value = ROUTES.ORDERS.SEARCH;

        createModal({
            component: (
                <OrdersSearch
                    controller={controller}
                    route={ROUTES.ORDERS.SEARCH}
                    selected={selected}
                    setData={setData}
                    setSelected={setSelected}
                    setStock={setSelected}
                    onSearch={(criteria, _callback) => {
                        runSearch(criteria, { limit: 100, offset: 0 }, _callback)
                    }}
                />
            ),
            closable: true,
            title: "Orders Search",
            callback: () => {

                window.bm_state.value = route;
            }
        });
    };


    const runSearch = (criteria, page, onComplete = () => { }) => {



        const { type, values } = criteria;

        const hasValue = Object.values(values).some(val => val && val.toString().trim() !== "");
        
        if (!hasValue) {
            setIsSearchMode(false);
            setSearchCriteria(null);
            get_initial({ sort: filters.sort, limit: filters.limit }, (_s, _r) => {
                if (_s) {
                    if (_r.rows_previous.length > 0) {
                        setAlign("start");
                    }
                    setData(_r.rows_previous.concat(_r.rows_next));
                    setSelected((_r.rows_next.length > 0) ? _r.rows_next[0] : {});
                } else {
                    showError(_r);
                }
                onComplete(_s, _r);
            });
            return;
        }


        let api = "";
        let payload = {
            limit: page.limit,
            offset: page.offset,
        };

        switch (type) {
            case "isbn":
                api = "order.searchByISBN";
                payload = {
                    isbn: values.isbn,
                    limit: page.limit,
                    offset: page.offset,
                };
                break;

            case "title":
                api = "order.searchByTitle";
                payload = {
                    title: values.title,
                    limit: page.limit,
                    offset: page.offset,
                };
                break;

            case "customer":
                api = "order.searchByCustomer";
                payload = {
                    customer_id: values.customer_id,
                    limit: page.limit,
                    offset: page.offset,
                };
                break;

            case "order":
                api = "order.searchByOrder";
                payload = {
                    order_num: values.order || undefined,
                    supplier: values.order_supplier || undefined,
                    title: values.order_title || undefined,
                    limit: page.limit,
                };
                break;

            case "supplier":
                api = "order.searchBySupplier";
                payload = {
                    supplier: values.supplier,
                    title: values.supplier_title || undefined,
                    limit: page.limit,
                    offset: page.offset,
                };
                break;

            case "invoice":
                api = "order.searchByInvoice";
                payload = {
                    invoice_num: values.invoice,
                    supplier: values.invoice_supplier || undefined,
                    title: values.invoice_title || undefined,
                    limit: page.limit,
                    offset: page.offset,
                };
                break;

            case "specials":
                api = "order.searchByChronological";
                payload = {
                    start_from: values.specials || "N",
                    limit: page.limit,
                    offset: page.offset,
                };
                break;

            default:
                setLoading(false);
                showError("Unsupported search type");
                return;
        }




        pubCall(api, payload, (_s, _r) => {

            onComplete(_s, _r);
            if (!_s) {
                showError(_r);
                return;
            }

            setIsSearchMode(true);

            if (type === "order") {
                setData(_r.rows_previous.concat(_r.rows_next));
                setSelected((_r?.rows_next?.length > 0) ? _r.rows_next[0] : {});
            } else {
                setData(_r?.rows || []);
                if (_r?.rows) {
                    setSelected(_r.rows[0])
                }
            }

        });
    };


    useEffect(() => {
        if (!searchCriteria) return;

        runSearch(searchCriteria, pagination);
    }, [searchCriteria, pagination]);


    useEffect(() => {
        setIsSearchMode(false);
    }, [filters]);


    const nextPage = () => {
        setPagination(prev => ({
            ...prev,
            offset: prev.offset + prev.limit,
        }));
    };

    const prevPage = () => {
        setPagination(prev => ({
            ...prev,
            offset: Math.max(0, prev.offset - prev.limit),
        }));
    };

    const [stock, setStock] = useState(null);
    const returnRoute = useRef();


    const getStock = (_primary_code, _condition_code, _callback) => {

        if (!_primary_code) {
            return;
        }

        pubCall("stock.getSingleByCode", { primary_code: _primary_code, condition_code: _condition_code }, (_s, _r) => {
            _callback(_s, _r)
        });

    }

    useEffect(() => {

        Cookies.set("selected_order", selected?.order_id);
        const debouncerTimer = setTimeout(() => {
            getStock(selected?.primary_code, selected?.condition_code, (_s, _r) => {
                if (_s) {

                    setStock(_r);
                } else {
                    showError(_r);
                }
            })
        }, 300);

        return () => {
            clearTimeout(debouncerTimer);
        }
    }, [selected])


    const editISBN = (_primary_code, _condition_code) => {

        getStock(_primary_code, _condition_code, (_s, _r) => {
            if (_s) {
                // do stuff
                setStock(_r);
                setState(prev => ({
                    ...prev,
                    view: "inventory",
                    edit: false,
                }));
                returnRoute.current = window.bm_state.value;
                window.bm_state.value = ROUTES.INVENTORY.EDIT;
            } else {
                showError(_r);
            }
        })


    }


    return (
        <div className="controller">
            <div style={{ height: "calc(100vh - 140px)", minHeight: "511px", gap: "15px" }}>

                <div style={{ "height": "calc(100vh - 415px)", "minHeight": "236px", "backgroundColor": (state.view === "inventory") ? "var(--card-bg)" : "transparent" }}>
                    {(state?.view === "inventory") &&


                        <InventoryDetails
                            edit={(window.bm_state.value === ROUTES.INVENTORY.EDIT)}
                            controller={controller}
                            stock_data={stock || {}}
                            callback={() => {
                                alert("hi")
                            }}
                            switchEdit={(stock) => {

                                if (stock) {
                                    showMessage("Saved")
                                }
                                window.bm_state.value = returnRoute?.current;
                                setStock(null)
                                setState(prev => ({
                                    ...prev,
                                    view: "orders",
                                    edit: "true"
                                }));
                            }}
                        />
                    }
                    <div style={{ height: (state.view === "inventory") ? "0px" : "auto", "overflow": (state.view === "inventory") ? "hidden" : "visible" }}>
                        <div style={{"paddingTop" : "0px"}}>
                        

                            <OrdersList
                                controller={controller}
                                loading={loading}
                                setLoading={setLoading}
                                route={route}
                                data={data}
                                setData={setData}
                                selected={selected}
                                setSelected={setSelected}
                                signal={signal}
                                align={align}
                                setAlign={setAlign}
                                view={view}
                                filters={filters}
                                setFilters={setFilters}
                                row_key={row_key}
                                isSearchMode={isSearchMode}
                            />
                        </div>
                    </div>
                </div>
                


                <OrdersDetails editISBN={editISBN} state={state} route={ROUTES.ORDERS.EDIT} controller={controller} setSelectedItem={setSelectedItem} setSelected={setSelected} items={items} setItems={setItems} selected={selected} callback={() => {
                    setState({ ...state, "edit": false })
                }} />


            </div>

            <Divider />
            <div style={{ 'height': "30px" }}>
                <Space style={{ "padding": "0px" }}>
                    <Nav nav={order_nav} />
                </Space>
            </div>

        </div>
    )
}


